import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import { Button } from '../Typography'

const NavStyle = styled.nav`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  z-index: 3;

  .nav-item {
    padding: 0.25rem 0.75rem;
    cursor: pointer;
    transition: 0.3s ease-out opacity;
    transform: translateY(-0.16rem);

    &:hover {
      opacity: 0.6;
    }
  }
`

const Icon = styled.div`
  margin-right: 1rem;
  width: 2rem;

  img {
    width: 100%;
  }
  transition: 0.3s ease-out opacity;
  &:hover {
    opacity: 0.6;
  }
`

const src = '/images/skyweaver-symbol.svg'

const Nav = () => {
  return (
    <NavStyle>
      <Icon className="no-aria">
        <Link to="/">
          <img src={src} alt="Skyweaver Icon" />
        </Link>
      </Icon>

      <Link to="/how-to-play">
        <Button className="nav-item">How To Play</Button>
      </Link>

      <a
        href="https://play.skyweaver.net/market/cards/buy"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button className="nav-item">Cards</Button>
      </a>

      <Link to="/lore">
        <Button className="nav-item">Lore</Button>
      </Link>
    </NavStyle>
  )
}

export default Nav
